import { Col, Radio, Row, Spin } from 'antd';
import PropTypes from 'prop-types';
import { ActionsEditSummaryItem } from './ActionsEditSummaryItem';
import { TitleSummary } from '../../../style';
import { useRadioConditionalFields } from '../../hooks/useRadioConditionalFields';

export const EditSummaryRadioField = ({ field, onFinish }) => {
  const {
    selectedIdInput,
    conditionalFields,
    templateRadioItems,
    loadingTemplate,
    getConditionalFields,
    handleRadioChange,
  } = useRadioConditionalFields({ field });

  const handleSave = () => {
    const selectedTemplateItem = templateRadioItems?.find((t) => t.idInput === selectedIdInput);
    const newValue = { selectedItem: selectedIdInput };
    if (selectedTemplateItem?.conditional) {
      console.log({
        templateRadioItems,
        selectedIdInput,
        selectedTemplateItem,
      });
      newValue.valueConditional =
        conditionalFields.length > 0 ? conditionalFields : getConditionalFields({ idInput: selectedIdInput });
    }
    onFinish({ save: true, newValue });
  };

  const handleCancel = () => {
    onFinish();
  };

  return (
    <>
      <Row align="middle">
        <TitleSummary style={{ marginBottom: 0, marginRight: 8 }}>{field.label}</TitleSummary>
        <ActionsEditSummaryItem handleCancel={handleCancel} handleSave={handleSave} />
      </Row>
      <Row style={{ marginTop: 8 }}>
        <Col md={24}>
          <Spin spinning={loadingTemplate}>
            <Radio.Group value={selectedIdInput} style={{ width: '100%' }} onChange={handleRadioChange}>
              {field.value?.map((item) => (
                <Row key={item.idInput} align="middle" style={{ width: '100%', marginBottom: 4 }}>
                  <Radio value={item.idInput}>
                    <span>{item.label}</span>
                  </Radio>
                </Row>
              ))}
            </Radio.Group>
          </Spin>
        </Col>
      </Row>
    </>
  );
};

EditSummaryRadioField.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.array,
  }),
  onFinish: PropTypes.func,
};
